import * as z from "zod";

import { ZoneUserRole } from "constants/userContstants";

export const userFormSchema = z.object({
  first_name: z.string(),
  last_name: z.string(),
  profession: z.string().nullable().optional(),
  email: z.string(),
  roles: z.array(z.enum(Object.values(ZoneUserRole))),
  zones: z.array(z.string()),
  preferences: z.object({ language: z.string() }).optional(),
  metadata: z.object().optional(),
});

export type UserFormSchema = z.infer<typeof userFormSchema>;
